import { initializeApp } from 'firebase/app';
import { getToken, deleteToken, getMessaging, onMessage } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyDUBiPpfJiW0clhCMO7Htr55ND8QZ5fjOs",
    authDomain: "playme-e3382.firebaseapp.com",
    databaseURL: "https://playme-e3382.firebaseio.com",
    projectId: "playme-e3382",
    storageBucket: "playme-e3382.appspot.com",
    messagingSenderId: "108053838400",
    appId: "1:108053838400:web:3adac92bd344f1a26cbda5",
    measurementId: "G-3NQ8NPLRPS"
};

console.log('*** Environment ***', window.__RUNTIME_CONFIG__.REACT_APP_ENV)
console.log('*** Firebase Config ***', firebaseConfig)

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const getFirebaseApp = () => {
    return firebaseApp
}
export const getOrRegisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    return window.navigator.serviceWorker
        .getRegistration('/firebase-push-notification-scope')
        .then((serviceWorker) => {
          if (serviceWorker) return serviceWorker;
          return window.navigator.serviceWorker.register(process.env.PUBLIC_URL + '/firebase-messaging-sw.js');
        });
  }
  throw new Error('The browser doesn`t support service worker.');
};

export const askForPermissionToReceiveNotifications = async () => {
    try {

        // console.log("registrationApp==>", registrationApp)
        // const messaging = firebaseApp.messaging();
        await Notification.requestPermission();
        let token = "";
        await deleteFirebaseToken()
        token = await getFirebaseToken()
        // console.log('fcm old token : ', oldToken);
        console.log('fcm new token : ', token);
        return token;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const deleteFirebaseToken = () => {
    getOrRegisterServiceWorker()
        .then((serviceWorkerRegistration) =>
            deleteToken(messaging, {serviceWorkerRegistration}));
}

export const getFirebaseToken = () =>
    getOrRegisterServiceWorker()
        .then((serviceWorkerRegistration) =>
            getToken(messaging, {  vapidKey: "BGZJpQ1x0RMi8S02O5RdZrVvB-Zbzras-OlisJa8wZchwlK9iZTfcA5CHrrsrZtqtVnvEDkQtqGgSjR_2ymW1f4", serviceWorkerRegistration }));

export const onForegroundMessage = () =>
    new Promise((resolve) => onMessage(messaging, (payload) => {
        // console.log("onForegroundMessage",payload)
        resolve(payload)
    }));